export enum EXAMPLE_TYPES {
  OBJECT = 'OBJECT',
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
  WEBHOOKS = 'WEBHOOKS',
  WEBHOOKS_INTRO = 'WEBHOOKS_INTRO',
  JS_FUNCTION = 'JS_FUNCTION',
}
